import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class ImagePreviewController extends Controller {
  static targets = ['image', 'initials', 'input', 'removeBtn', 'removeField']
  static values = { initials: String }

  triggerFileInput () {
    this.inputTarget.click()
  }

  readURL () {
    const file = this.inputTarget.files[0]

    if (file && file.size / (1024 * 1024) <= 5) {
      const reader = new window.FileReader()

      reader.onload = () => {
        this.imageTarget.src = reader.result
        this.imageTarget.classList.remove('hidden')
        this.initialsTarget.classList.add('hidden')
        this.removeBtnTarget.classList.remove('hidden')
      }

      reader.readAsDataURL(file)
    } else {
      window.alert('File size must be under 5 MB')
    }
  }

  removeImage () {
    this.imageTarget.src = ''
    this.imageTarget.classList.add('hidden')
    this.initialsTarget.classList.remove('hidden')

    this.inputTarget.value = ''
    this.removeBtnTarget.classList.add('hidden')

    if (this.removeFieldTarget) {
      this.removeFieldTarget.value = 'true'
    }
  }
}

stimulus.register('image-preview', ImagePreviewController)
